/**
 * Owner-admin API client for the Lead Engine.
 *
 * Talks to /api/admin/v2/leads/* — IsSuperuser-only per the backend
 * permission. Wrappers keep component code free of axios noise.
 */
import api from "./axios";

const BASE = "/api/admin/v2/leads";

// ── Lead CRUD ────────────────────────────────────────────────────────

export const listLeads = (params = {}) =>
  api.get(`${BASE}/`, { params });

export const getLead = (id) =>
  api.get(`${BASE}/${id}/`);

export const createLead = (payload) =>
  api.post(`${BASE}/`, payload);

export const updateLead = (id, payload) =>
  api.patch(`${BASE}/${id}/`, payload);

export const deleteLead = (id) =>
  api.delete(`${BASE}/${id}/`);

// ── CSV import ───────────────────────────────────────────────────────

// Template download — return the absolute URL so the SPA can window.open().
export const csvTemplateUrl = () => `${BASE}/csv-template/`;

export const previewLeadsCsv = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`${BASE}/csv-preview/`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const commitLeadsCsv = (rows) =>
  api.post(`${BASE}/csv-commit/`, { rows });
